import { memo, ReactElement } from 'react';
import { IRadioButtonChip } from '.';

const RadioButtonChip = (props: IRadioButtonChip): ReactElement => {
	const { label, options, value, onChange, onBlur, required = false, error, disabled } = props;
	return (
		<div className="chips-radio-group">
			<span className={`chips-radio-label ${required ? 'required' : ''}`}>{label}</span>
			<div className="chips-radio-options">
				{options.map((opt) => (
					<button
						key={opt.id}
						type="button"
						className={`btn btn-primary chip-btn ${value === opt.value ? 'selected' : ''}`}
						onClick={() => onChange(opt.value)}
						onBlur={onBlur}
						disabled={disabled}
					>
						{opt.icon && <span className={`${opt.icon} chip-icon`}></span>}
						<span>{opt.label}</span>
					</button>
				))}
			</div>
			{error && <p className={`error-message ${error && 'show'}`}>{error}</p>}
		</div>
	);
};

export default memo(RadioButtonChip);
